'use client';

import { c as _c } from "react/compiler-runtime";
import { BirthdayAppealAccepted } from './birthday-appeal-accepted.tsx';
import { BirthdayAppealAdd } from './birthday-appeal-add.tsx';
import type { BirthdayAppealAmountOption } from './birthday-appeal.logic.ts';
export interface BirthdayAppealProps {
  childName: string;
  amountOptions: BirthdayAppealAmountOption[];
  defaultAmount?: string;
  isAdded?: boolean;
  isBusy?: boolean;
  title?: string;
  addedTitle?: string;
  imageUrl?: string;
  imageAlt?: string;
  price?: string;
  className?: string;
  background?: string;
  flush?: boolean;
  onAdd: (amount: string) => void;
  onEdit?: () => void;
  onRemove: () => void;
  onAmountChange?: (amount: string) => void;
}
export const BirthdayAppeal: React.FC<BirthdayAppealProps> = t0 => {
  const $ = _c(28);
  const {
    childName,
    amountOptions,
    defaultAmount,
    isAdded: t1,
    isBusy: t2,
    title,
    addedTitle,
    imageUrl,
    imageAlt,
    price,
    className,
    background,
    flush: t3,
    onAdd,
    onEdit,
    onRemove,
    onAmountChange
  } = t0;
  const isAdded = t1 === undefined ? false : t1;
  const isBusy = t2 === undefined ? false : t2;
  const flush = t3 === undefined ? false : t3;
  if (isAdded) {
    const selectedValue = defaultAmount ?? amountOptions[0]?.value;
    let t4;
    if ($[0] !== amountOptions || $[1] !== selectedValue) {
      let t5;
      if ($[3] !== selectedValue) {
        t5 = option => option.value === selectedValue;
        $[3] = selectedValue;
        $[4] = t5;
      } else {
        t5 = $[4];
      }
      t4 = amountOptions.find(t5);
      $[0] = amountOptions;
      $[1] = selectedValue;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    const selectedOption = t4;
    const resolvedPrice = price ?? selectedOption?.label ?? selectedOption?.value ?? selectedValue;
    let t5;
    if ($[5] !== addedTitle || $[6] !== background || $[7] !== childName || $[8] !== className || $[9] !== flush || $[10] !== imageAlt || $[11] !== imageUrl || $[12] !== isBusy || $[13] !== onEdit || $[14] !== onRemove || $[15] !== resolvedPrice) {
      t5 = <BirthdayAppealAccepted childName={childName} isBusy={isBusy} addedTitle={addedTitle} imageUrl={imageUrl} imageAlt={imageAlt} price={resolvedPrice} className={className} background={background} flush={flush} onEdit={onEdit} onRemove={onRemove} />;
      $[5] = addedTitle;
      $[6] = background;
      $[7] = childName;
      $[8] = className;
      $[9] = flush;
      $[10] = imageAlt;
      $[11] = imageUrl;
      $[12] = isBusy;
      $[13] = onEdit;
      $[14] = onRemove;
      $[15] = resolvedPrice;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  let t4;
  if ($[17] !== amountOptions || $[18] !== background || $[19] !== childName || $[20] !== className || $[21] !== defaultAmount || $[22] !== flush || $[23] !== isBusy || $[24] !== onAdd || $[25] !== onAmountChange || $[26] !== title) {
    t4 = <BirthdayAppealAdd key={defaultAmount} childName={childName} amountOptions={amountOptions} defaultAmount={defaultAmount} isBusy={isBusy} title={title} className={className} background={background} flush={flush} onAdd={onAdd} onAmountChange={onAmountChange} />;
    $[17] = amountOptions;
    $[18] = background;
    $[19] = childName;
    $[20] = className;
    $[21] = defaultAmount;
    $[22] = flush;
    $[23] = isBusy;
    $[24] = onAdd;
    $[25] = onAmountChange;
    $[26] = title;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  return t4;
};